"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOffers = void 0;
var _shoppingContext = require("@ori/shopping-context");
/**
 * Hook to get offers from the shopping context.
 * isLoading is true until first shopping context load is complete.
 * offers returns empty array if there is no data.
 */
const useOffers = () => {
  const {
    isLoaded,
    isLoading,
    shoppingContext: {
      unitDataCollection = []
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const offersCollection = unitDataCollection.find(x => x.unitName === 'Offers');
  const {
    offers = []
  } = offersCollection ?? {};
  return {
    loading: isLoading && !isLoaded,
    offers
  };
};
exports.useOffers = useOffers;